// src/components/nodes/featureOverlay/modules/SmartplayCentral.js
import React, { useRef } from 'react';
import UplynkCentralModule from './UplynkCentralModule';

const SmartplayCentral = ({ id, data, showAllModuleOverlays }) => {

  return (
    <>
      <UplynkCentralModule 
        dataPath="uplynkCentral.data.jobStates"  // Path to "items" in the state object
        keyMappings={{
          state: "state",                       // Maps component's state key to data property
          progress: "progress",                 // Maps progress display text field
          progressPercent: "progress_percent",  // Maps numerical progress percentage
          timestamp: "timestamp"                // Maps time information field
        }}
        stateStyles={{
          states: {
            // Visual styling for each state (border color and progress bar color)
            ["assigned"]: { border: 'border-indigo-500', progress: 'bg-[#a5b4fc] border-indigo-600' },
            ["done"]: { border: 'border-green-600', progress: 'bg-[#009900] border-purple-600' },
            ["error"]: { border: 'border-red-600', progress: 'bg-red-400 border-red-600' },
            ["playing"]: { border: 'border-purple-500', progress: 'bg-purple-300 border-purple-400' },
            ["starting"]: { border: 'border-blue-500', progress: 'bg-blue-200 border-blue-500' },
            ["waiting"]: { border: 'border-amber-600', progress: 'bg-amber-300 border-amber-600' },
          }
        }}
        conditions={[
          // Condition to show live indicator during active slicing below 100%
          // {
          //   when: {
          //     property: "progress",
          //     values: ["Slicing"],
          //     comparison: "equals",
          //     and: {
          //       property: "progressPercent",
          //       value: 100,
          //       comparison: "lessThan"
          //     }
          //   },
          //   then: {
          //     showLiveIndicator: true  // Shows pulsing "Live" indicator
          //   }
          // },
          // Changes module status to "complete" when item is done successfully
          {
            when: {
              property: "state",
              comparison: "equals",
              values: ["playing"],
              // and: {
              //   property: "progress",
              //   values: ["Finished successfully"],
              //   comparison: "equals"
              // }
            },
            then: {
              removeClasses: "active-item-pulse",  // Removes pulsing effect
              // setStatus: "complete",            // moduleStatus will handle
              isCompleted: true                    // Flags item as completed
            }
          },
          // Changes module status to "canceled" on error
          {
            when: {
              property: "state",
              values: ["error"],
              comparison: "equals"
            },
            then: {
              removeClasses: "active-item-pulse",  // Removes pulsing effect
              // setStatus: "canceled",               // Updates module status to canceled
              isError: true                        // Flags item as error
            }
          }
        ]}
        visualOptions={{
          height: "17rem",                  // Container height
          width: "17rem",                   // Container width
          // scrollToLatest: true,          // Auto-scroll not enabled
          itemOrder: "",                    // Empty = default (newest at bottom)
          highlightLatestOnly: true,        // Only highlight the most recent item
          contrastRatio: 0.7,               // Dimming factor for older items
          compactLayout: true,              // Uses tighter spacing
          autoScrollButton: false           // Hides scroll-to-bottom button
        }}
      />
    </>
  );
};

export default SmartplayCentral;